import { render } from "./Signup.vue?vue&type=template&id=2d4fa8b2"
import script from "./Signup.vue?vue&type=script&lang=js"
export * from "./Signup.vue?vue&type=script&lang=js"
script.render = render

export default script